import Vue from 'vue';
import App from './App.vue';
import vuetify from '@/plugins/vuetify';
import filters from '@/filters';
import module from '.';

Vue.config.productionTip = false;

Vue.use(filters);

module.component = new Vue({
  data: {
    module,
  },
  vuetify,
  render(h) {
    return h(App, {
      props: {
        module: this.module,
      },
    });
  },
}).$mount('#template');

window.MagTemplate = module;
